<template>
  <div class="main_box" v-loading.fullscreen="loading">
    <div class="full_layout">
      <div>
        <ul class="bids_tabs">
          <li @click="MsgTabs(6)" :class="msgTabs==6?'on':''">{{$t('base.order')}}<span v-if="MsgCount.OrderCount != 0">({{MsgCount.OrderCount}})</span></li>
          <li @click="MsgTabs(5)" :class="msgTabs==5?'on':''">{{$t('base.bids')}}<span v-if="MsgCount.AuctionCount != 0">({{MsgCount.AuctionCount}})</span></li>
          <li @click="MsgTabs(2)" :class="msgTabs==2?'on':''">{{$t('base.offer')}}<span v-if="MsgCount.ASKCount != 0">({{MsgCount.ASKCount}})</span></li>
          <li @click="MsgTabs(7)" :class="msgTabs==7?'on':''">{{$t('base.dispute')}}<span v-if="MsgCount.SRCount != 0">({{MsgCount.SRCount}})</span></li>
          <li @click="MsgTabs(1)" :class="msgTabs==1?'on':''">{{$t('base.fromCardHobby')}}<span v-if="MsgCount.SysCount != 0">({{MsgCount.SysCount}})</span></li>
        </ul>
      </div>
      <table-messages :list="list" showType="messages" @update="update" />

      <list-pagination class="full_layout" :TotalCount="TotalCount" :ps="ps" @ps='pageSize' @pi='pageIndex' />
    </div>
  </div>
</template>
<script>
/* 模拟假数据 */
import demo from '@/api/demo'

import { getInfo, getTime } from "@/api/public";
import TableMessages from '@/components/list/messages'
import ListPagination from '@/components/listpagination'
import bus from '@/api/bus';
export default {
  name: '',
  components: { TableMessages, ListPagination },
  data() {
    return {
      list: [],
      userInfo: null,
      msgTabs: 6,
      MsgCount: '',
      TotalCount: 0,
      pi: 1,
      ps: 60,
      show: false,
      loading:false
    }
  },
  created() {
    bus.$emit('headerTitle', this.$t('title.notification'));
    this.userInfo = getInfo()
    this.getNotificationCount()
    this.getMyNotification()
  },
  mounted() {},
  methods: {
    showCount(val){
      console.log(111,val)
    },
    MsgTabs(val) {
      let that = this;
      that.pi = 1;
      that.ps = 60;
      that.msgTabs = val;
      this.getMyNotification()
    },
    // 获取信息总数
    getNotificationCount() {
      let that = this
      let data = { operator_id: this.userInfo.MappingUserId, memberid: this.userInfo.MappingUserId, token: this.userInfo.ChineseToken }
      this.$get(this.$interface.NotificationCount, data).then(res => {
        if (res.result != 0) {
          this.MsgCount = res.data
        }
      })
    },
    // 获取信息列表
    getMyNotification() {
      let that = this
      that.loading=true;
      let data = { operator_id: this.userInfo.MappingUserId, memberid: this.userInfo.MappingUserId, token: this.userInfo.ChineseToken, MessageType: that.msgTabs, pageIndex: that.pi, pageSize: that.ps }
      this.$get(this.$interface.MyNotificationForWeb, data).then(res => {
        if (res.result != 0) {
          that.TotalCount = res.count;
          if(that.userInfo.IsSeller){
            res.data.map(item=>{
              item.seller=false
              if(item.CreateUser!=that.userInfo.MappingUserId){
                item.seller=true
              }
            })
          }
          that.list = res.data
      that.loading=false;
        }
        //console.log(res)
      })
      //MyNotificationForWeb
    },
    // 刷新信息列表（子）
    update(){
      this.getMyNotification()
      this.getNotificationCount()
    },
    // 每页几条
    pageSize(val) {
      this.ps = val
      this.getMyNotification();

    },
    // 页码
    pageIndex(val) {
      this.pi = val
      this.getMyNotification();
    },
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bids_tabs {
  height: 48px;
  line-height: 48px;
  border-bottom: 1px solid #e0e0e0;
  display: flex;
  font-size: 16px;
  text-align: center;
  margin-top: 20px;
}

.bids_tabs li {
  line-height: 48px;
  border: 1px solid #e0e0e0;
  border-bottom: none;
  border-right: none;
  /*min-width: 180px;*/
  min-width: 100px;
  padding: 0 20px;
  cursor: pointer;
  box-sizing: border-box;
}

.bids_tabs li:last-child {
  border-right: 1px solid #f0f0f0;
}

.bids_tabs li.on {
  background-color: #5F6DAE;
  color: #fff;
}

</style>



// WEBPACK FOOTER //
// src/pages/messages/index.vue